import { jsx as _jsx } from "react/jsx-runtime";

function SvgEmail() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.088 5.806c.163-.389.532-.639.912-.639h16c.38 0 .749.25.912.64L12 12.304 3.088 5.806zM3 8.217l8.41 6.133a1 1 0 001.18 0L21 8.217V18.75c0 .633-.49 1.084-1 1.084H4c-.51 0-1-.451-1-1.084V8.217zm20-1.95V18.75c0 1.66-1.31 3.084-3 3.084H4c-1.69 0-3-1.424-3-3.084V6.25v-.002c.001-1.658 1.31-3.081 3-3.081h16c1.683 0 2.989 1.412 3 3.062a.92.92 0 010 .037z"
    }, void 0)
  }), void 0);
}

export default SvgEmail;